import { render, staticRenderFns } from "./CreateDatabaseForm.vue?vue&type=template&id=2c885413&"
import script from "./CreateDatabaseForm.vue?vue&type=script&lang=js&"
export * from "./CreateDatabaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c885413')) {
      api.createRecord('2c885413', component.options)
    } else {
      api.reload('2c885413', component.options)
    }
    module.hot.accept("./CreateDatabaseForm.vue?vue&type=template&id=2c885413&", function () {
      api.rerender('2c885413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Databases/CreateDatabaseForm.vue"
export default component.exports